"use strict";
import React, { Component, ReactNode } from "react";
import {
  Text,
  View,
  SafeAreaView,
  ActivityIndicator,
  StyleSheet,
} from "react-native";
import { BlurView } from "expo-blur";
//import EStyleSheet from "react-native-extended-stylesheet";
import { Theme, Spinner } from "@app/ui";

interface Props {
  children: ReactNode;
  blur: Boolean;
  showDragPane: Boolean;
  rounded: Boolean;
  opacity: number;
  title?: string;
  margin: Boolean;
  isLoading?: Boolean;
}

interface State {}

class Card extends Component<Props, State> {
  public static defaultProps = {
    blur: false,
    showDragPane: false,
    rounded: false,
    opacity: 1,
    margin: false,
  };

  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  renderDragPane() {
    return (
      <View style={{ padding: 14, alignItems: "center" }}>
        <BlurView
          tint={"light"}
          intensity={24}
          style={{
            height: 5,
            width: 38,
            borderRadius: 4,
            overflow: "hidden",
            //opacity: 0.5,
          }}
        ></BlurView>
      </View>
    );
  }

  renderTitle() {
    return (
      <View style={styles.titleContainer}>
        <Text style={styles.title}>{this.props.title}</Text>
      </View>
    );
  }

  renderContent() {
    return (
      <View style={{ marginBottom: 24 }}>
        {this.props.showDragPane && this.renderDragPane()}
        {this.props.title && this.renderTitle()}
        <View
          style={{
            marginVertical: 32,
            marginHorizontal: 32,
          }}
        >
          {this.props.children}
        </View>
      </View>
    );
  }

  renderLoading() {
    return (
      <View>
        {this.props.showDragPane && this.renderDragPane()}
        <Spinner
          color="#ffffff"
          size="large"
          marginSize="large"
          style={{ flex: 1, margin: 44 }}
        />
      </View>
    );
  }

  render() {
    const borderRadius = this.props.rounded ? 16 : 0;
    const margin = this.props.margin ? 0 : 0;

    if (this.props.blur) {
      const blurAmount = this.props.blur ? 100 : 0;
      return (
        <View style={{ borderRadius, overflow: "hidden" }}>
          <BlurView tint="dark" intensity={blurAmount} style={{ borderRadius }}>
            {this.renderContent()}
          </BlurView>
        </View>
      );
    } else {
      return (
        <View
          style={[
            styles.container,
            //styles.containerShadow,
            { borderRadius, margin },
          ]}
        >
          {this.props.isLoading ? this.renderLoading() : this.renderContent()}
        </View>
      );
    }
  }
}

const styles = StyleSheet.create({
  title: {
    height: 44,
    lineHeight: 44,
    fontSize: 17,
    textAlign: "center",
    //fontFamily: "$fontFamilyMedium",
    alignItems: "center",
    color: Theme.colors.text, //"$textColor",
    letterSpacing: -0.7,
  },
  titleContainer: {
    borderBottomWidth: 0.5,
    //borderBottomColor: "$lineSeparatorHigh",
  },
  container: {
    backgroundColor: Theme.colors.chromeHigh, // "$chromeHighColor",
    //overflow: 'hidden',
    //borderTopColor: Theme.colors.separatorHigh, // "$lineSeparatorHigh",
    borderWidth: 0,
  },
  containerShadow: {
    shadowColor: "black",
    shadowOffset: {
      width: 0,
      height: 12,
    },
    shadowOpacity: 1,
    shadowRadius: 20,
    elevation: 18,
  },
});

export default Card;
